/**
 * SCM enrollment bindings carried by a Sectigo SCM CA connector. The names
 * match the signer registry (signer/internal/protocol ProfilePolicy
 * `scm_organization_id` / `scm_certificate_type_id`), which the SCM provider
 * sends to POST /api/ssl/v2/enroll as `orgId` and `certType`.
 */
export const SCM_CONNECTOR_ID_FIELDS = ["scm_organization_id", "scm_certificate_type_id"];
/** SCM identifiers are 32-bit signed integers in the SCM REST API. */
export const SCM_ID_MAX = 2_147_483_647;
const LABELS = {
    scm_organization_id: "SCM organization ID",
    scm_certificate_type_id: "SCM certificate type ID",
};
export function isScmId(value) {
    return typeof value === "number" && Number.isSafeInteger(value) && value > 0 && value <= SCM_ID_MAX;
}
/** SCM ID fields a Sectigo SCM connector lacks (or holds invalid values for). Always empty for other providers. */
export function missingScmConnectorIds(connector) {
    if (connector.provider !== "sectigo_scm")
        return [];
    return SCM_CONNECTOR_ID_FIELDS.filter((field) => !isScmId(connector[field]));
}
/** Create/update validation: both IDs are required for Sectigo SCM and forbidden for every other provider. */
export function scmConnectorIdProblem(connector) {
    if (connector.provider !== "sectigo_scm") {
        const present = SCM_CONNECTOR_ID_FIELDS.filter((field) => connector[field] !== undefined && connector[field] !== null);
        return present.length ? `${present.map((field) => LABELS[field]).join(" and ")} is only valid for Sectigo SCM connectors` : undefined;
    }
    const missing = missingScmConnectorIds(connector);
    return missing.length
        ? `${missing.map((field) => LABELS[field]).join(" and ")} must be a positive whole number from your SCM account`
        : undefined;
}
//# sourceMappingURL=ca-connector.js.map